import React, { useCallback, useState } from "react";
import type { PointData } from "pixi.js";
import { Container, Graphics, Text } from "pixi.js";
import { extend } from "@pixi/react";

extend({ Text });
extend({ Graphics });
extend({ Container });

interface PixBimContextMenuItemProps {
  index: number;
  onClick?: (action: string) => void;
  text: string;
  width: number;
  textColor?: string;
  fontSize: number;
}

const PixBimContextMenuItem: React.FC<PixBimContextMenuItemProps> = ({
  onClick,
  index = 0,
  text = "hej",
  width = 150,
  fontSize = 14,
  textColor = "#000000",
}) => {
  const [isHover, setIsHover] = useState(false);
  const lineHeight = fontSize * 1.4;
  const y = index * lineHeight;
  const draw = useCallback(
    (g: Graphics) => {
      g.clear();
      g.drawRoundedRect(0, 0, width, lineHeight, 4);
      g.eventMode = "static";
      g.fill({ color: isHover ? "#1e90ff" : "#EEEEEE" });
    },
    [lineHeight, width, isHover]
  );

  const onMenuItemClick = (text: string) => {
    onClick && onClick(text);
  };
  const position: PointData = {
    x: 0,
    y,
  };
  const onPointerOver = () => {
    setIsHover(true);
  };

  const onPointerOut = () => {
    setIsHover(false);
  };

  return (
    <container
      position={position}
      onPointerOver={onPointerOver}
      onPointerOut={onPointerOut}
      eventMode="static"
    >
      <graphics draw={draw} />
      <pixiText
        text={text}
        interactive={true}
        cursor="pointer"
        style={{
          fontSize,
          align: "left",
          fill: isHover ? "white" : textColor,
          wordWrap: true,
          wordWrapWidth: 150,
        }}
        position={{ x: 5, y: 2 }}
        zIndex={1}
        onClick={() => onMenuItemClick(text)}
      />
    </container>
  );
};

export default PixBimContextMenuItem;
